import { CSSObject } from '@chakra-ui/react';

export const GridLayout: CSSObject = {
  background: [null, null, 'gray.200'],
  minH: '100dvh',
  width: ['100dvw', null, '760px'],
  borderRadius: [null, null, 'lg'],
  display: 'flex',
  alignItems: [null, null, 'center'],
  mx: 'auto',
};
